const KeenSlider = window.KeenSlider

const { setInitialised, useAutoplay } = window.BAO.Carousel.plugins
const { debounce } = window.BAO.Utils

class AnnouncementBar extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
    this.updateColours(0)

    this.setAnnouncementHeight = this.setAnnouncementHeight.bind(this)
    this.setAnnouncementHeight()
  }

  setupListeners () {
    super.setupListeners()

    this.debouncedResize = debounce(() => {
      this.setAnnouncementHeight()
    }, 240)
    this.listeners.add(window, 'resize', this.debouncedResize)

    if (!this.els?.dismiss.exists) return

    this.handleDismiss = this.handleDismiss.bind(this)
    this.listeners.add(this.els.dismiss.element, 'click', this.handleDismiss)
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    this.onSlideChanged = this.onSlideChanged.bind(this)

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: true,
        renderMode: 'custom',
        slideChanged: this.onSlideChanged,
      },
      [setInitialised(), useAutoplay(this.autoplay, { pauseOnHover: true })],
    )
  }

  onSlideChanged (instance) {
    const currentSlide = instance.track.details.rel

    this.els.slide.elements.forEach((slide, index) => {
      slide.setAttribute('aria-hidden', index !== currentSlide)
    })

    this.updateColours(currentSlide)
  }

  setAnnouncementHeight () {
    if (this.classList.contains('hd-AnnouncementBar-hidden')) return

    const minHeight = 40
    const announcementHeight = this.offsetHeight

    document.body.style.setProperty(
      '--Announcement_Height',
      `${announcementHeight > minHeight ? announcementHeight : minHeight}px`,
    )
  }

  updateColours (currentIndex) {
    this.els.banner.elements.forEach((element, index) => {
      if (index !== currentIndex) return

      const backgroundColour = element.dataset.backgroundColour
      const contentColour = element.dataset.contentColour

      this.style.setProperty('--Section_Background', backgroundColour)
      this.style.setProperty('--Section_Content', contentColour)
    })
  }

  async handleDismiss () {
    this.classList.toggle('hd-AnnouncementBar-hidden')

    document.body.style.setProperty('--Announcement_Height', `0px`)

    await window.BAO.Cart.updateCartAttributes({
      dismissed_announcement: this.announcementId,
    })
  }

  get autoplay () {
    return parseInt(this.dataset.autoplay)
  }

  get announcementId () {
    return this.dataset.announcementId
  }
}

if (!customElements.get('announcement-bar')) {
  customElements.define('announcement-bar', AnnouncementBar)
}
